import { configData } from "../../config";

// The country and state lists the lead forms offer (the quick, DOC Talks and referral forms), loaded
// once and shared: { countries: [{ value, label }], states: [{ name, abbreviation, country }] }.
// The forms send a state's code, so states without one are left out, and they are listed by
// name as Drupal listed them. country is the state's country code (US / CA) where the API
// gives it; an older API gives none, and a form that lists the states of one country then
// lists them all.
// The provinces of Canada by code. A state's own country is not enough to split the lists by: the
// states table, as Drupal's, files Wyoming under Canada.
export const CANADIAN_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

let listsPromise = null;
export const loadCountryStateLists = () => {
    if (!listsPromise) {
        const get = (path) => fetch(configData.APP_URL + path)
            .then((response) => response.json())
            .then((data) => Object.values(data?.data?.result || {}));
        listsPromise = Promise.all([get('smwwcountries/getcountrieslist'), get('smwwstates/getstatelist')])
            .then(([countries, states]) => ({
                countries,
                states: states.filter((state) => state.abbreviation).sort((a, b) => a.name.localeCompare(b.name)),
            }))
            .catch((err) => {
                listsPromise = null;
                console.error(err);
                return { countries: [], states: [] };
            });
    }
    return listsPromise;
};
